import React from "react";

import withAuthorization from "./withAuthorization";
import { Drawer } from "@material-ui/core";

class HomePage extends React.Component {
  componentWillMount() {
    // window.location = "/";
  } 

  render() {
    return (
      <div>
        {/* {console.log(this.props)} */}
        <h1>Home Page</h1>
        <p>The Home Page is accessible by every signed in user.</p>
      </div>
    );
  }
}

// checks if the authUser object is not null
const authCondition = authUser => !!authUser;

// export default withAuthorization(authCondition)(HomePage);
export default withAuthorization(authCondition)(HomePage);
